import { render } from "./FacetPanel.vue?vue&type=template&id=24507bce&scoped=true&ts=true"
import script from "./FacetPanel.vue?vue&type=script&lang=ts"
export * from "./FacetPanel.vue?vue&type=script&lang=ts"

import "./FacetPanel.vue?vue&type=style&index=0&id=24507bce&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24507bce"]])

export default __exports__